import React from 'react';
import CartonMaterialsSectionWrapper from 'components/quote_builder_widget/sections/CartonMaterialsSectionWrapper';
import CorrugatedMaterialsSectionWrapper from 'components/quote_builder_widget/sections/CorrugatedMaterialsSectionWrapper';
import styles from 'components/quote_builder_widget/settings/_style.module.scss';

const MATERIAL_SECTIONS = [
  { id: 'carton_materials', label: 'quote_builder_widget.section_carton_materials', Content: CartonMaterialsSectionWrapper },
  { id: 'corrugated_materials', label: 'quote_builder_widget.section_corrugated_materials', Content: CorrugatedMaterialsSectionWrapper },
];

const MaterialsMenuSection = ({ activeSection, onSectionChange, onMaterialsChange }) => {
  const activeMaterialSection = MATERIAL_SECTIONS.find((section) => section.id === activeSection) || MATERIAL_SECTIONS[0];
  const { Content } = activeMaterialSection;

  return (
    <div className={styles.materialsLayout}>
      <nav className={`dct-menu__panel ${styles.materialsMenu}`} aria-label={t('quote_builder_widget.section_materials')}>
        <ul className="dct-menu__list">
          {MATERIAL_SECTIONS.map((section) => {
            const isCurrent = section.id === activeMaterialSection.id;
            return (
              <li key={section.id}>
                <a
                  href={`#${section.id}`}
                  className={isCurrent ? 'dct-menu__link is-current' : 'dct-menu__link'}
                  aria-current={isCurrent ? 'page' : undefined}
                  onClick={(event) => {
                    event.preventDefault();
                    onSectionChange(section.id);
                  }}
                >
                  {t(section.label)}
                </a>
              </li>
            );
          })}
        </ul>
      </nav>

      <div className={styles.materialsContent}>
        <Content onMaterialsChange={onMaterialsChange} />
      </div>
    </div>
  );
};

export default MaterialsMenuSection;
